import { useEffect, useRef } from 'react'
import { dangKyThongBaoRealtime, type ThongBaoRealtimeHandlers } from '@/services/thongBaoRealtime'

/** Nghe thông báo realtime khi `enabled` (handler luôn lấy bản mới nhất, không mở lại socket). */
export const useThongBaoRealtime = (enabled: boolean, handlers: ThongBaoRealtimeHandlers) => {
  const ref = useRef(handlers)
  ref.current = handlers

  useEffect(() => {
    if (!enabled) return
    return dangKyThongBaoRealtime({
      onMoi: (tb) => ref.current.onMoi?.(tb),
      onCapNhat: () => ref.current.onCapNhat?.(),
    })
  }, [enabled])
}
